module.exports = __webpack_public_path__ + "static/media/Mark.3fc685bb.jpg";